import { ThemeProvider } from 'styled-components';
import { AuthProvider } from '../contexts/AuthContext';
import { MQTTProvider } from '../contexts/MQTTContext';
import { DeviceProvider } from '../contexts/DeviceContext';
import { StoreProvider } from '../contexts/StoreContext';
import { theme } from '../styles/theme';

const AppProvider = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <DeviceProvider>
                <AuthProvider>
                    <StoreProvider>
                        <MQTTProvider>
                            {children}
                        </MQTTProvider>
                    </StoreProvider>
                </AuthProvider>
            </DeviceProvider>
        </ThemeProvider>
    );
};

export default AppProvider;